import {
    type TextStyle,
    StyleSheet
} from "react-native";
import type {
    PopoverSurfaceHeadingDynamicStyleType,
    PopoverSurfaceHeadingVariant
} from "./type";
import type {
    Mutable
} from "../../../../types";

export const POPOVER_SURFACE_HEADING_VARIANT: keyof NCoreUIKit.Typography = "labelSmallSize";

export const POPOVER_SURFACE_HEADING_TOP_KEYS: Record<PopoverSurfaceHeadingVariant, keyof NCoreUIKit.Spaces> = {
    popover: "spacingSm",
    sheet: "spacingMd"
};

const stylesheet = StyleSheet.create({
    heading: {
        alignSelf: "stretch"
    }
});

export const useStyles = ({
    variant,
    spaces
}: PopoverSurfaceHeadingDynamicStyleType) => {
    const styles = {
        heading: {
            paddingTop: spaces[POPOVER_SURFACE_HEADING_TOP_KEYS[variant]],
            paddingHorizontal: spaces.spacingSm,
            paddingBottom: spaces.spacingXs
        } as Mutable<TextStyle>
    };

    if(variant === "sheet") {
        styles.heading.paddingHorizontal = spaces.spacingLg - spaces.spacingXs;
    }

    return styles;
};
export default stylesheet;
